<template>
  <div>
    <v-switch v-model="need" label="Нужно фильтровать"></v-switch>
    <v-btn class="success" @click="saveFilter">Сохранить</v-btn>
  </div>
</template>

<script>
import AttestationService from '@/services/AttestationService'

export default {
  props: {
    id: String
  },
  data: () => ({
    need: false,
    attestationService: undefined
  }),
  created () {
    this.attestationService = new AttestationService(this.$store)
    this.attestationService.needFilter(this.id, (data) => {
      if (data) {
        this.need = data.status
      }
    })
  },
  methods: {
    saveFilter () {
      this.attestationService.saveFilter(Number.parseInt(this.id), this.need, (data) => {
        if (data.status) {
          alert('ОК')
        } else {
          alert('Ошибка')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/attesation_info/student/Filter.vue